/* ------------------------------------------------------------------
   Canonical list of event-type buckets
------------------------------------------------------------------ */
export const EVENT_CATEGORIES = Object.freeze({
  TAP: 'tap',
  TOGGLE: 'toggle',
  SCREEN_VIEW: 'screen_view',
  IMPRESSION: 'impression',
  SWIPE: 'swipe'
})

/* ------------------------------------------------------------------
   Unique event-names agreed with Product
------------------------------------------------------------------ */
export const EVENTS = Object.freeze({
  /* screen-views */
  VIEWED_LOGIN_PAGE: 'viewed_login_page',
  VIEWED_OTP_VERIFICATION_PAGE: 'viewed_otp_verification_page',
  VIEWED_PASSWORD_PAGE: 'viewed_password_page',
  VIEWED_RESET_PASSWORD: 'viewed_reset_password',

  /* taps / fields */
  TAP_FIELD: 'tap_field',
  TAP_LOGIN_WITH_OTP: 'tap_login_with_otp',
  TAP_LOGIN_WITH_PASSWORD: 'tap_login_with_password',
  TAP_FORGOT_PASSWORD: 'tap_forgot_password',
  TAP_LOGIN: 'tap_login',
  TAP_CONTINUE: 'tap_continue',
  TAP_BACK_TO_LOGIN: 'tap_back_to_login',
  TAP_CONTINUE_TO_LOGIN: 'tap_continue_to_login',
  TAP_EDIT_NUMBER: 'tap_edit_number',
  TAP_NEW_PASSWORD: 'tap_new_password',
  TAP_CONFIRM_PASSWORD: 'tap_confirm_password',

  /* auth helpers */
  MOBILE_NUMBER_ENTERED: 'mobile_number_entered',
  OTP_VERIFICATION_INITIATED: 'otp_verification_initiated',
  RESEND_OTP: 'resend_otp',
  OTP_VERIFICATION_SUCCESS: 'otp_verification_successful',
  OTP_VERIFICATION_FAILED: 'otp_verification_failed',
  PASSWORD_VERIFICATION_FAILED: 'password_verification_failed',
  PASSWORD_MISMATCH: 'password_mismatch',

  /* dashboard & plans (already there) */
  CARD_IMPRESSION: 'card_impression',
  TAP_POST_JOB_CTA: 'tap_post_job_CTA',
  TAP_PLAN_BASIC: 'tap_plan_basic',
  TAP_PLAN_PREMIUM_PLUS: 'tap_plan_premium_plus',
  TAP_PLAN_PREMIUM: 'tap_plan_premium',
  TAP_SUBMISSION: 'tap_submission',
  TAP_COMPLETE_POSTING: 'tap_complete_posting',
  DOWNLOAD_EXCEL: 'download_excel',
  TAP_CALL: 'tap_call',

  /* Hamburger menu */
  TAP_MY_PROFILE: 'tap_my_profile',
  TAP_POST_A_JOB: 'tap_post_a_job',
  TAP_CONTACT_US: 'tap_contact_us',
  TAP_LOGOUT: 'tap_logout',
  TAP_DOWNLOAD_APP: 'tap_download_app',

  TAP_GO_TO_CHECKOUT: 'tap_go_to_checkout',
  VIEWED_PROFILE_PAGE: 'viewed_profile_page',
  TAP_PAYMENT_HISTORY: 'tap_payment_history',
  TAP_MENU: 'tap_menu',
  TAP_FIND_A_JOB: 'tap_find_a_job',

  /*  ───────── new for Job-form header ───────── */
  TAP_BACK: 'tap_back',
  TAP_GO_TO_DASHBOARD: 'tap_go_to_dashboard',

  /* form – fee section (step-1) */
  SELECTED_REASONS_FOR_FEE: 'selected_reasons_for_fee',
  SELECTED_FEE_TO_BE_PAID: 'selected_fee_to_be_paid',

  TAP_SKILLS_REQUIRED: 'tap_skills_required',
  TOGGLED_SKILLS: 'toggled_skills',
  TAP_ADD_OTHER_SKILLS: 'tap_add_other_skills',
  TAP_ADD: 'tap_add',
  TAP_SUBMIT: 'tap_submit',
  ENTERED_COMPANY_EMAIL: 'entered_company_email',
  TAP_NEXT_COMPANY_DETAILS: 'tap_next_company_details',
  TAP_EDIT_JOB_POST: 'tap_edit_job_post',
  TOGGLED_UPSELLING_PLAN: 'toggled_upselling_plan',

  TAP_FAQ: 'tap_faq',
  SELECT_ALL: 'select_all',
  TAP_CALL_CTA: 'tap_call_cta',
  TAP_DATABASE_CANDIDATES: 'tap_database_candidates',
  TAP_DEACTIVATE_JOB: 'tap_deactivate_job',
  TAP_DEACTIVATE_POST: 'tap_deactivate_post',
  TAP_DOWNLOAD_RESUME: 'tap_download_resume',
  TAP_EDIT_REPOST: 'tap_edit_repost',
  TAP_PROCEED_TO_PAY: 'tap_proceed_to_pay',
  TAP_RATE_YOUR_EXP: 'tap_rate_your_exp',
  TAP_RESPONSES: 'tap_responses',
  TAP_SHARE: 'tap_share',
  TAP_SIGN_OUT: 'tap_sign_out',
  TAP_VERIFIED_CANDIDATES: 'tap_verified_candidates',
  TAP_VIEW_COMPLETE_POST: 'tap_view_complete_post',
  TAP_VIEW_PROFILE: 'tap_view_profile',
  TAP_VIEW_RESUME: 'tap_view_resume',
  TOGGLED_ACTIVE: 'toggled_active',
  TOGGLED_ALL_JOBS: 'toggled_all_jobs',
  TOGGLED_EXPIRED: 'toggled_expired',
  VIEWED_AGENT_CHECKOUT: 'viewed_agent_checkout',
  VIEWED_PROFILE_DETAILS_SCREEN: 'viewed_profile_details_screen',
  VIEWED_SUBMISSION_DETAILS_SCREEN: 'viewed_submission_details_screen',
  BACK_ALL_JOBS: 'back_all_jobs',
  TAP_CANCEL: 'tap_cancel',
  TAP_EDIT_JOB: 'tap_edit_job',
  TAP_DELETE_POST: 'tap_delete_post',
  VIEW_DASHBOARD_JOBS: 'view_dashboard_jobs',
  VIEWED_PAYMENT_HISTORY: 'viewed_payment_history',
  JOB_TITLE_SELECTED: 'job_title_selected',
  JOB_ROLE_SELECTED: 'job_role_selected',
  TAP_EDIT_HIRING_LOCATION: 'tap_edit_hiring_location',
  HIRING_LOCATION_SELECTED: 'hiring_location_selected',
  COURSE_SELECTED: 'course_selected',
  CERTIFICATE_SELECTED: 'certificate_selected',
  TAP_COURSE_NAME: 'tap_course_name',
  TAP_SEARCH_COURSE: 'tap_search_course',
  TAP_LOOKING_FOR_JOB: 'tap_looking_for_job',
  TAP_TRY_ENT_SOL: 'tap_try_ent_sol',
  TAP_CONTINUE_HIRING: 'tap_continue_hiring',
  TAP_LEAVE_PAGE: 'tap_leave_page',
})

/* ------------------------------------------------------------------
   Event → default category lookup
------------------------------------------------------------------ */
export const EVENT_CONFIG = {
  /* ---------- screen-views ---------- */
  [EVENTS.VIEWED_LOGIN_PAGE]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_OTP_VERIFICATION_PAGE]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_PASSWORD_PAGE]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_RESET_PASSWORD]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_PROFILE_PAGE]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_AGENT_CHECKOUT]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_PROFILE_DETAILS_SCREEN]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_SUBMISSION_DETAILS_SCREEN]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEWED_PAYMENT_HISTORY]: { category: EVENT_CATEGORIES.SCREEN_VIEW },
  [EVENTS.VIEW_DASHBOARD_JOBS]: { category: EVENT_CATEGORIES.SCREEN_VIEW },

  /* ---------- impressions ---------- */
  [EVENTS.CARD_IMPRESSION]: { category: EVENT_CATEGORIES.IMPRESSION },

  /* ---------- toggles ---------- */
  [EVENTS.TOGGLED_SKILLS]: { category: EVENT_CATEGORIES.TOGGLE },
  [EVENTS.TOGGLED_UPSELLING_PLAN]: { category: EVENT_CATEGORIES.TOGGLE },
  [EVENTS.TOGGLED_ACTIVE]: { category: EVENT_CATEGORIES.TOGGLE },
  [EVENTS.TOGGLED_ALL_JOBS]: { category: EVENT_CATEGORIES.TOGGLE },
  [EVENTS.TOGGLED_EXPIRED]: { category: EVENT_CATEGORIES.TOGGLE },
  [EVENTS.SELECT_ALL]: { category: EVENT_CATEGORIES.TOGGLE }
  /*  all other events inherit the default `tap` category  */
}
